import React from "react";
import styles from "./ChristmasBanner.module.scss";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import botLeft1 from 'images/Game City Rewards/_0017_Food-Strawberry.png.png';
import botLeft2 from 'images/Game City Rewards/avatar-8.png';
import botLeft3 from 'images/Game City Rewards/bot_left_v2.png';
import botRight1 from 'images/Game City Rewards/_0019_Food-Donut.png.png';
import botRight2 from 'images/Game City Rewards/avatar-9.png';
import botRight3 from 'images/Game City Rewards/bot_right_v2.png';
import PricingFunctions from "common/PricingFunctions";

const ChristmasBanner = ({ showTopRibbon = true, showBottomRibbon = false, showShopButton = true, color, shrinkAvatars = false }) => {
    const pricing = useSelector(state => state.pricing);
    let countryCode = pricing.countryCode;
    const navigate = useNavigate();

    // Get regional pricing thresholds
    const localeLower = PricingFunctions.getRewardsLower(countryCode);
    const localeMid = PricingFunctions.getRewardsMid(countryCode);
    const currencySymbol = PricingFunctions.getCurrencySymbol(countryCode);

    const now = new Date();
    const isChristmas = now.getMonth() === 11 && (now.getDate() < 26 || (now.getDate() === 26 && now.getHours() < 8));

    const discountCode = isChristmas ? "FESTIVEFUN30" : "NEWYEAR40";
    const discountPercent = isChristmas ? "30%" : "40%";
    const titleText = isChristmas ? "Get the festive party started!" : "New Year's sale now on!";
    const ribbonLabel = isChristmas ? "MERRY CHRISTMAS" : "HAPPY NEW YEAR";

    const ribbonText = Array(10).fill(ribbonLabel).map((text, index) => (
        <span key={index} className={styles.ribbonText}>
            {text} <span className={styles.dot}>•</span>
        </span>
    ));

    const isMobileWidth = () => {
        return window.innerWidth < 500;
    }

    return (
        <div className={`${styles.christmasBanner} ${!showShopButton ? styles.noButton : ''}`} style={color ? { backgroundColor: color } : undefined}>
            {/*<img className={`${styles.bot} ${styles.left} ${styles.three} ${shrinkAvatars && styles.small}`} src={botLeft2} alt="bot-left" />*/}
            {/*<img className={`${styles.bot} ${styles.left} ${styles.two} ${shrinkAvatars && styles.small}`} src={botLeft3} alt="bot-left" />*/}
            {/*<img className={`${styles.bot} ${styles.left} ${styles.one} ${shrinkAvatars && styles.small}`} src={botLeft1} alt="bot-left" />*/}
            {/*<img className={`${styles.bot} ${styles.right} ${styles.three} ${shrinkAvatars && styles.small}`} src={botRight3} alt="bot-right" />*/}
            {/*<img className={`${styles.bot} ${styles.right} ${styles.two} ${shrinkAvatars && styles.small}`} src={botRight2} alt="bot-right" />*/}
            {/*<img className={`${styles.bot} ${styles.right} ${styles.one} ${shrinkAvatars && styles.small}`} src={botRight1} alt="bot-right" />*/}

            {showTopRibbon && !isMobileWidth() &&
                <div className={styles.ribbon}>
                    <div className={styles.ribbonContent}> {ribbonText}{ribbonText} </div>
                </div>
            }

            <h2 className={styles.title}>{titleText}</h2>
            <p className={styles.description}>
                Use {discountCode} for {discountPercent} off ALL games!
            </p>

            {showShopButton && <button onClick={() => navigate(`/shop?discountCode=${discountCode}`)} className={`${styles.button} ${styles.alternate} ${styles.wide}`}>SHOP & SAVE</button>}

            {showBottomRibbon &&
                <div className={`${styles.ribbon} ${styles.bottom}`}>
                    <div className={styles.ribbonContent}> {ribbonText}{ribbonText} </div>
                </div>
            }
        </div>
    );
};

export default ChristmasBanner;